import * as React from "react";

class CheckboxWrap extends React.Component {
	public render() {
		return (
			<div className="form-item form-group form-item form-type-checkbox form-group">
				<fieldset>{this.props.children}</fieldset>
			</div>
		);
	}
}

export default CheckboxWrap;
